// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"7905a2ab","86":"167fb311","272":"51d47876","283":"c6eb908e","453":"821fd3de","509":"5d2cdc42","778":"ec411908","780":"ee95fa06","831":"05dfbe6e","836":"155f4508","842":"439cf561","917":"98e6bca6","953":"8fc66599"}[chunkId] + ".chunk.js";
};